<template>
  <v-container fluid class="pa-5 pb-16 elevation-1">
    <!-- HEADER -->
     <v-sheet class="pa-4 w-100 app-header" color="#194c9b" elevation="2" rounded>
      <h1 class="text-h4 font-weight-bold d-flex align-center">
        <div class="header-content">
            <v-btn
              v-bind="props"
              icon
              elevation="2"
              color="blue"
            >
              <v-img
              v-bind="props"
              :src="chatgptIcon"
              class="header-icon cursor-pointer"
              color="black"
              contain
              />
            </v-btn>
            <span class="header-title">ChatGPT</span>
        </div>
      </h1>
    </v-sheet>
    <v-card class="chat-card">
        <!-- HEADER -->
        <v-toolbar density="comfortable" class="chat-toolbar">
            <div class="chat-toolbar-left">
                <div class="icono">
                    <v-avatar size="28">
                    <v-img class="header-icon cursor-pointer" :src="chatgptIcon" />
                    </v-avatar>
                </div>

                <div class="chat-toolbar-title">
                    <span class="title-main">ChatGPT</span>
                    <span v-if="project" class="title-sub">
                        · {{ project.nameProyect ?? project.nombre ?? project.idProyect ?? project.clave }}
                    </span>
                </div>
            </div>

            <v-spacer />

            <v-btn icon variant="text" @click="$emit('update:modelValue', false)">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-toolbar>

        <v-divider />

        <!-- BODY (scroll) -->
        <v-card-text ref="chatBody" class="chat-body">
        <div v-if="messages.length === 0 && !loading" class="empty-chat">
            <div class="text-h6 mb-1">¿En qué te ayudo?</div>
            <div class="text-body-2 text-medium-emphasis">
            Escribe una pregunta o selecciona una sugerencia.
            </div>

            <div class="d-flex flex-wrap ga-2 mt-3">
            <v-chip variant="tonal" @click="archivo='Resume este proyecto'">Resume este proyecto</v-chip>
            <v-chip variant="tonal" @click="archivo='Dame riesgos y tareas'">Riesgos y tareas</v-chip>
            <v-chip variant="tonal" @click="archivo='Genera casos de prueba'">Casos de prueba</v-chip>
            </div>
        </div>

        <div v-for="(m, i) in messages" :key="i" class="msg" :class="m.role === 'user' ? 'msg-user' : 'msg-bot'">
            <div class="bubble">{{ m.content }}</div>
        </div>

        <div v-if="loading" class="msg msg-bot">
            <div class="bubble">Escribiendo...</div>
        </div>
        </v-card-text>

        <v-divider />

        <!-- FOOTER (input fijo) -->
        <v-card-actions class="chat-footer">
        <v-textarea
            v-model="archivo"
            rows="1"
            auto-grow
            variant="outlined"
            density="comfortable"
            placeholder="Pregunta lo que quieras…"
            class="chat-input"
            @keydown.enter.exact.prevent="enviarMensaje"
        />

        <v-btn
            icon
            color="primary"
            class="send-inline"
            :disabled="!archivo?.trim() || loading"
            :loading="loading"
            @click="enviarMensaje"
        >
            <v-icon>mdi-send</v-icon>
        </v-btn>
    </v-card-actions>
    </v-card>
</v-container>
</template>

<script>
import "@/css/ChatGPT/StyleChatView.css"
import chatgptIcon from "@/assets/chatgpt.png"

export default {
  name: "ChatVIew", 
  props: {
    clave: { type: String, required: true }
  },
  emits: ["update:modelValue"],
  data() {
    return {
      chatgptIcon,
      project: null,
      messages: [],
      loading: false,
      archivo: "",
      API_URL: "http://127.0.0.1:8005/login/chat/"
    }
  },
  async mounted() {
    await this.loadProject()
  },

  methods: {
    async loadProject() {
      const API_BASE = "http://127.0.0.1:8005"
      const resp = await fetch(`${API_BASE}/login/proyectos/${encodeURIComponent(this.clave)}/`)
      if (resp.ok) this.project = await resp.json()
    },
    async enviarMensaje() {
      const text = (this.archivo || "").trim();
      if (!text || this.loading) return;

      this.messages.push({ role: "user", content: text });
      this.archivo = "";
      this.scrollToBottom();

      this.loading = true;
      try {
        const res = await fetch(this.API_URL, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ mensaje: text }), 
        });

        if (!res.ok) throw new Error(`HTTP ${res.status}`);

        const data = await res.json();

        const reply = data.respuesta ?? "Sin respuesta";

        this.messages.push({ role: "assistant", content: reply });
        this.scrollToBottom();
      } catch (e) {
        console.error(e);
        this.messages.push({
          role: "assistant",
          content: e,
        });
        this.scrollToBottom();
      } finally {
        this.loading = false;
      }
    },

    scrollToBottom() {
      this.$nextTick(() => {
        const el = this.$refs.chatBody;
        if (!el) return;
        el.scrollTop = el.scrollHeight;
      });
    },
  },
}
</script>
